export const HeaderTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] as const
export const Variants = ['default', 'compact'] as const

export const defaultVariant = 'default'
export const defaultIsSelectable = false
export const defaultTitle = 'List view' as const
export const defaultTitleHeaderTag = 'h2'
export const defaultItemHeaderTag = 'h3'
export const defaultTotalCount = 3
export const defaultSelectedCount = 0
